import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const WAREHOUSE_LOCATIONS_API_URL =
  process.env.REACT_APP_WAREHOUSE_LOCATIONS_API_URL || buildApiUrl('/warehouse-locations');

export async function fetchWarehouseLocationBranches() {
  const response = await requestWarehouseLocationApi(`${WAREHOUSE_LOCATIONS_API_URL}/branches`, {
    fallbackMessage: 'Unable to load e-Portal branches right now.',
  });

  return response.json();
}

export async function fetchWarehouseLocations() {
  const response = await requestWarehouseLocationApi(WAREHOUSE_LOCATIONS_API_URL, {
    fallbackMessage: 'Unable to load warehouse locations right now.',
  });

  return response.json();
}

export async function createWarehouseLocation(payload) {
  const response = await requestWarehouseLocationApi(WAREHOUSE_LOCATIONS_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to save warehouse location right now.',
  });

  return response.json();
}

export async function updateWarehouseLocation(id, payload) {
  const response = await requestWarehouseLocationApi(`${WAREHOUSE_LOCATIONS_API_URL}/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to update warehouse location right now.',
  });

  return response.json();
}

export async function deleteWarehouseLocation(id) {
  const response = await requestWarehouseLocationApi(`${WAREHOUSE_LOCATIONS_API_URL}/${id}`, {
    method: 'DELETE',
    fallbackMessage: 'Unable to delete warehouse location right now.',
  });

  return response.json();
}

async function requestWarehouseLocationApi(url, options) {
  const { fallbackMessage, ...requestOptions } = options;
  let response;

  try {
    response = await fetch(url, {
      ...requestOptions,
      headers: withBusinessHeaders(requestOptions.headers),
    });
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error, fallbackMessage));
  }

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || fallbackMessage);
  }

  return response;
}

function getNetworkErrorMessage(error, fallbackMessage) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline right now. Please reconnect to continue.';
  }

  if (error instanceof TypeError) {
    return 'Unable to reach the server right now. Please check your connection or try again in a moment.';
  }

  return fallbackMessage;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
